import { Form } from "react-bootstrap";
import { FiMoon, FiSun } from "react-icons/fi";
import useTheme from "./useTheme";

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="popover-item">
      <div className="hstack justify-content-between w-100">
        <span className="text-dark">
          {theme === "dark" ? <FiMoon /> : <FiSun />} Theme
        </span>

        <Form.Check
          type="switch"
          checked={theme === "dark"}
          onChange={() =>
            setTheme(theme === "dark" ? "light" : "dark")
          }
        />
      </div>
    </div>
  );
};

export default ThemeToggle